<script setup lang="ts">
import { UiAvatar, UiIcon, UiLink, UiText, HiredOnShopexpertsBadge, generateInitials, ensureProtocol } from '@shopexperts/shared';
import { computed } from 'vue';

const props = defineProps<{
  name: string;
  avatarUrl?: string | null;
  companyName: string;
  companyWebsite?: string | null;
  isRepeatClient: boolean;
  isHiredOnShopexperts: boolean;
  postedAt?: string;
}>();

const companyUrl = computed(() => {
  return ensureProtocol(props.companyWebsite) || '#';
});
</script>

<template>
  <div class="flex items-start gap-3 flex-1">
    <UiAvatar
      :url="props.avatarUrl || undefined"
      :initials="generateInitials(props.name)"
      size="xs"
    />
    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-2">
        <UiText as="p" variant="h6" class="font-semibold" :text="props.name" />
        <UiIcon
          name="repeat"
          v-if="props.isRepeatClient"
          class="w-5 h-5 text-gray-400"
        />
        <HiredOnShopexpertsBadge
          :hired-on-shopexperts="props.isHiredOnShopexperts"
          size="xs"
        />
      </div>
      
      <UiLink 
        variant="h6"
        external="with-arrow" 
        :href="companyUrl" 
        :label="props.companyName" 
      />
      <UiText as="p" variant="p-small" class="text-gray-500" :text="`Posted At: ${props.postedAt}`" v-if="props.postedAt" />
    </div>
  </div>
</template>

